/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyDeliveryPostalArea,
  PharmacyDeliveryPostalAreaFromJSON,
  PharmacyDeliveryPostalAreaFromJSONTyped,
  PharmacyDeliveryPostalAreaToJSON,
} from "./";

export const GetPharmacyDeliveryPostalAreasResponseTypename = "GetPharmacyDeliveryPostalAreasResponse" as const;

/**
 *
 * @export
 * @interface GetPharmacyDeliveryPostalAreasResponse
 */
export interface GetPharmacyDeliveryPostalAreasResponse {
  /**
   *
   * @type {Array<PharmacyDeliveryPostalArea>}
   * @memberof GetPharmacyDeliveryPostalAreasResponse
   */
  deliveryPostalAreas?: Array<PharmacyDeliveryPostalArea>;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetPharmacyDeliveryPostalAreasResponse
   */
  readonly __typename?: string;
}

export function GetPharmacyDeliveryPostalAreasResponseFromJSON(json: any): GetPharmacyDeliveryPostalAreasResponse {
  return GetPharmacyDeliveryPostalAreasResponseFromJSONTyped(json, false);
}

export function GetPharmacyDeliveryPostalAreasResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPharmacyDeliveryPostalAreasResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetPharmacyDeliveryPostalAreasResponseTypename,

    deliveryPostalAreas: !exists(json, "delivery_postal_areas")
      ? undefined
      : (json["delivery_postal_areas"] as Array<any>).map(PharmacyDeliveryPostalAreaFromJSON),
  };
}

export function GetPharmacyDeliveryPostalAreasResponseToJSON(
  object?: GetPharmacyDeliveryPostalAreasResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    delivery_postal_areas:
      value.deliveryPostalAreas === undefined
        ? undefined
        : (value.deliveryPostalAreas as Array<any>).map(PharmacyDeliveryPostalAreaToJSON),
  };
}
